import { render, staticRenderFns } from "./FFCHome.vue?vue&type=template&id=1843c1be&lang=pug&"
import script from "./FFCHome.vue?vue&type=script&lang=js&"
export * from "./FFCHome.vue?vue&type=script&lang=js&"
import style0 from "./FFCHome.vue?vue&type=style&index=0&theme=ffc&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports